const IDENTIFYCONFIG = {
  country: "MX",
  language: "ES",
  porcobrar: true
}

export {
  IDENTIFYCONFIG
};


// WEBPACK FOOTER //
// ./src/constants/segment.js